import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=c8539a92&scoped=true&"
import script from "./footers.vue?vue&type=script&lang=js&"
export * from "./footers.vue?vue&type=script&lang=js&"
import style0 from "./footers.vue?vue&type=style&index=0&id=c8539a92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8539a92",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavCollapseList: require('D:/Project/kpwebsite/H5/components/nav/navCollapseList.vue').default})
